<!--  -->
<template>
  <div style="margin-top:6vh">
    <div class="title">
      <div class="title-text">设备总览</div>
    </div>
    <div class="item" v-for="(item,i) in basedata" :key="i">
      <div class="left">
        <img :src="item.src" />
        <div class="text">{{item.name}}</div>
      </div>
      <div class="right">
        <div class="right-item" style="margin-bottom:0.5vh">
          <div class="txt">正常</div>
          <div class="normal">{{item.normal}}</div>
        </div>
        <div class="right-item">
          <div class="txt">正常</div>
          <div class="abnormal">{{item.abnormal}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      basedata: [
        {
          src: require("../../assets/jk.png"),
          name: "监控设备",
          normal: 12,
          abnormal: 0
        },
        {
          src: require("../../assets/xfy.png"),
          name: "消防设备",
          normal: 8,
          abnormal: 2
        },
        {
          src: require("../../assets/dzwl.png"),
          name: "电子围栏",
          normal: 4,
          abnormal: 0
        },
        {
          src: require("../../assets/hjjc.png"),
          name: "环境检测",
          normal: 10,
          abnormal: 0
        }
      ]
    };
  },

  components: {},

  computed: {},

  methods: {}
};
</script>
<style lang="less" scoped>
.item {
  display: flex;
  font-family: sy;
  margin-left: 4px;
  margin-top: 1vh;
  margin-bottom: 2.8vh;
  .left {
    background: url(../../assets/sbbox.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    width: 2.61vw;
    height: 4.63vh;
    margin-right: 7px;
    text-align: center;
    img {
      margin-top: 6px;
      height: 2vh;
    }
    .text {
      margin-top: -4px;
      font-size: 0.4vh;
      color: rgba(255, 255, 255, 0.502);
    }
  }
  .right {
    .right-item {
      width: 183px;
      height: 2.36vh;
      background: url(../../assets/tbox2.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      color: #fff;
      font-weight: 600;
      .txt {
        font-size: 0.6vh;
        margin-left: 15px;
        margin-right: 90px;
      }
      .normal {
        font-size: 2vh;
        color: #98fef9;
      }
      .abnormal {
        font-size: 2vh;
        color: #ff9600;
      }
    }
  }
}
</style>